import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  AnimatedView,
  Panel,
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCol
} from "../../../components";
import Highlight from "react-highlight";
import { history } from "../../../redux/store/configureStore";
import * as qs from "query-string";
import { Link } from "react-router-dom";
import Pagination from "react-js-pagination";
import { appConfig } from "../../../config";
import {
  Button,
  FormGroup,
  InputGroup,
  FormControl,
  Alert,
  ButtonGroup,
  MenuItem,
  DropdownButton,
  Modal,
  ControlLabel,
} from "react-bootstrap";
import { createHashHistory } from "history";
import { Notification } from "../../../components/notifications";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import auth from "../../../services/auth";
import Switch from "react-switch";
import isEmpty from "lodash.isempty";
import Dialog from "react-bootstrap-dialog";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { withRouter } from "react-router-dom";
import { userList, userStatus, userDelete} from "../../../redux/actions/accessAction";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      no: 0,
      activePage: 1,
      msgType: "",
      alertMessage: "",
      search: "",
      limit: 15,
      direction: "",
      orderBy: "",
      userList: [],
      toggleActive: true,
      total: 0,
      per_page: 10,
      from: 0,
      show: false,
      showDialog: false,
      path: ["Home", "Super Admin List"],
      links: ["home","/superadmin/list"],
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    // this.confirmDelete = this.confirmDelete.bind(this);
    // this.handleShow = this.handleShow.bind(this);
    // this.handleCnameClose = this.handleCnameClose.bind(this);
    // this.handleCnameShow = this.handleCnameShow.bind(this);
    // this.handleChange = this.handleChange.bind(this);
    // this.handleDomainClose = this.handleDomainClose.bind(this);
    // this.handleDomainShow = this.handleDomainShow.bind(this);
    // this.handleInstallSSL = this.handleInstallSSL.bind(this);
    // this.handleInstallSSLClose = this.handleInstallSSLClose.bind(this);
    this.handleDeleteUser = this.handleDeleteUser.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleStatus = (e, user_id, status) => {
  	this.dialog.show({
      body: "Are you sure you want to change user status?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmhandleStatus(user_id, status);
          this.handleShow();
        })
      ]
    });
  }

  confirmhandleStatus(user_id, status){
  	if(status == 'Active'){
  		this.props.userStatus({superadminID: user_id, status: 'Inactive'}, 'superadmin/status');
  	}else{
  		this.props.userStatus({superadminID: user_id, status: 'Active'}, 'superadmin/status');
  	}
  }

  handleDeleteUser = (user_id) =>{
  	this.dialog.show({
      body: "Are you sure you want to delte this user?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmhandleDelete(user_id);
          this.handleShow();
        })
      ]
    });
  }

  confirmhandleDelete(user_id){
  	this.props.userDelete(`superadmin/delete/${user_id}`);
  }


  handleChange = (e) => {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({[e.target.name] : e.target.value, siteDomainError: ''});
  }

   handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });
    let searchstring = this.state.search.length > 1 ? this.state.search : "";
    const postData = {
      page: this.state.activePage,
      limit: this.state.limit,
      search: searchstring
    };
    if (this.state.search.length !== 0) {
    	this.props.userList(postData, 'superadmin/list');
    }else{
    	this.props.userList({page: this.state.activePage}, 'superadmin/list');
    }
  }

  handlePageChange = pageNumber => {
    const postData = {
      page: pageNumber,
      limit: this.state.limit,
      search: this.state.search ? this.state.search : ""
    };

    this.props.userList(postData, 'superadmin/list');
    this.setState({ activePage: pageNumber });
  };

  componentWillMount() {
    this.props.userList({page: this.state.activePage, limit: this.state.limit}, 'superadmin/list');
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.list != nextProps.list){
    	if(nextProps.list){
    		this.setState({userList: nextProps.list.data, total: nextProps.list.total, per_page: nextProps.list.per_page, from: nextProps.list.from});
    	}
    }

    if(this.props.status != nextProps.status){
    	if(nextProps.status){
    		this.handleShow();
    		this.props.userList({page: this.state.activePage}, 'superadmin/list');
    		this.props.clearAlert();
    		this.props.renderAlert("success", nextProps.status.data.message);
    	}
    }

    if(this.props.error != nextProps.error){
      if(nextProps.error){
        this.handleShow();
        this.props.userList({page: this.state.activePage}, 'superadmin/list');
        this.props.clearAlert();
        this.props.renderAlert("danger", nextProps.error);
        window.scrollTo(0, 0);
      }
    }

    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  
  render() {
    let from = this.state.from;
    const headerTitle = "Super Admin List";
    let superAdminList = [];

    if(!isEmpty(this.state.userList)){
    	superAdminList = this.state.userList.map((list, index) => (
    		<tr key={'list'+list.user_id}>
    			<td>{from++}</td>
	          	<td>{list.firstName} {list.lastName}</td>
	          	<td>{list.email}</td>
	          	<td>
	          		<Switch
		              onChange={e => {
		                this.handleStatus(e, list.user_id, list.status);
		              }}
		              checked={(list.status == 'Active') ? true : false}
		              id="normal-switch"
		            />
	          	</td>
	          	<td>
	          		<ButtonGroup>
		              <DropdownButton title="Action" id="bg-nested-dropdown">
		                <MenuItem onClick={() => history.push(`/superadmin/edit/${list.user_id}`)}>Edit</MenuItem>
		                <MenuItem onClick={this.handleDeleteUser.bind(this, list.user_id)}>Delete</MenuItem>
		              </DropdownButton>
		            </ButtonGroup>
	          	</td>
	         </tr>
    	));
    }
    return (
      <div className="col-xs-12 site-list">
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />

        <div className="row">
          <div className="col-xs-12">
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
          </div>
        </div>
        <div className="panel">
          <header className="panel-heading">Manage Super Admin</header>
          <div className="panel-body">
            <div className="col-xs-12">
              <Link to={"/superadmin/add"} className="pull-right btn btn-success">
                <b>
                  <i className="fa fa-plus" /> <b>Add New User</b>
                </b>
              </Link>
            </div>

            <div className="clearfix" />
            <div className="row m-t-15">
              <div className="col-lg-4 pull-right">
                <FormGroup>
                  <InputGroup>
                    <FormControl
                      type="text"
                      name="search"
                      onChange={this.handleSearch}
                      onBlur={this.handleSearch}
                    />
                    <InputGroup.Addon>
                      <i className="fa fa-search" />
                    </InputGroup.Addon>
                  </InputGroup>
                </FormGroup>
              </div>
            </div>

            <div className="col-lg-12">
              <table className="table table-hover" responsive="true">
                <thead>
                  <tr>
                    <th width="20%">S.No</th>
                    <th width="20%">Name</th>
                    <th width="20%">Email Address</th>
                    <th width="10%">Status </th>
                    <th width="20%">Actions</th>
                  </tr>
                </thead>
                <tbody>{superAdminList}</tbody>
              </table>

              <div className="text-center">
                <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
	error: state.user.error,
	list: state.user.list,
	status: state.user.status,
	alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
});


export default withRouter(connect(mapStateToProps, { userList, userStatus, userDelete, renderAlert, clearAlert })(List));



// WEBPACK FOOTER //
// ./src/app/views/Users/SuperAdmin/List.js